/**
 * @description
 */

import './iframe.scss';

import React, { useLayoutEffect, useEffect, useState, useRef, useMemo } from 'react';
import { components } from 'common';
const { Loading } = components;
const { If } = components;
import { $window } from '@umu/umu-dom';
import { throttle } from '@umu/umu-util';

interface IProps extends Omit<React.IframeHTMLAttributes<any>, 'id' | 'url'> {
    id?: string;
    url: string;
    topOffset?: number;
    uiOption?: {
        isHideLoadingIndicator: boolean; // 是否对onload等默认做loading
        isShowWhenPageLoading: boolean; // 是否在loading过程中隐藏
    },
    onLoad?: () => void;
    onDestory?: () => void;
}
const RESIZE_THROTTLE_TIME = 300; // resize函数的截断时间
export default function Iframe(props: IProps) {
    const [isLoading, setIsLoading] = useState(true);

    const windowInnerHeight = useMemo(() => window.innerHeight || document.documentElement.clientHeight, []);

    const [iframeHeight, setIframeHeight] = useState(windowInnerHeight);

    const elRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        return () => {
            onDestory();
        };
    }, []);

    useLayoutEffect(() => {
        bindEvents();
    }, []);

    const bindEvents = () => {
        const el = elRef.current;
        if (!el) {
            return;
        }
        el.addEventListener('load', onIframeLoaded, false);

        $window.addEventListener('orientationchange', onResize, false);
        $window.addEventListener('resize', onResize, false);
    };

    const onResize = throttle(() => {
        const height = window.innerHeight || document.documentElement.clientHeight;
        setIframeHeight(height);
    }, RESIZE_THROTTLE_TIME);

    const onIframeLoaded = () => {
        setIsLoading(false);
        if (props.onLoad) {
            props.onLoad();
        }
    };

    const onDestory = () => {
        const el = elRef.current;
        if (!el) {
            return;
        }

        el.removeEventListener('load', onIframeLoaded, false);

        if (props.onDestory) {
            props.onDestory();
        }
    };

    // shouldComponentUpdate(nextProps, nextState) {
    //     let isUpdate = false;
    //     if (this.state.iframeHeight != nextState.iframeHeight
    //         || this.state.iframeWidth != nextState.iframeWidth) {
    //         isUpdate = true;
    //     }

    //     if (this.state.loading != nextState.loading) {
    //         isUpdate = true;
    //     }

    //     if (this.props.url !== nextProps.url) {
    //         this.setState({
    //             loading: true
    //         });
    //         isUpdate = true
    //     }

    //     return isUpdate;
    // }

    const render = () => {
        const { url, topOffset, onLoad, ...otherProps } = props;

        if (!url) {
            return null;
        }

        const height = iframeHeight - (topOffset || 0);

        const visibility: React.CSSProperties['visibility'] = props.uiOption?.isShowWhenPageLoading ? (
            'visible'
        ): isLoading ? 'hidden' : 'visible';
        const style = {
            display: 'block',
            visibility,
        };
        return (
            <div className="iframe-wrapper">
                {
                    !props.uiOption?.isHideLoadingIndicator ? (
                        <If condition={isLoading}>
                            <div className="iframe-wrapping-loading opacity show">
                                <Loading />
                            </div>
                        </If>
                    ): null
                }
                <iframe
                    id={props.id || 'iframe-id'}
                    className="iframe"
                    height={height}
                    width={'100%'}
                    src={url}
                    style={style}
                    frameBorder={0}
                    allowFullScreen={true}
                    ref={elRef}
                    {...otherProps}
                ></iframe>
            </div>
        );
    };

    return render();
}
